// Theme: cyber-samurai-onyx
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cyber-samurai-onyx',
  name: 'CYBER SAMURAI ONYX',
  tagline: 'CYBER SAMURAI ONYX',
  description: 'Estrutura do Cyber Samurai com accent onyx-indigo.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#060608', '#0C1014', '#4F46E5', '#F3F6FB'],
  familyId: 'cyber-samurai',
  variantName: 'ONYX',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '0px',
      '--shadow-card': '0 0 0 1px rgba(79, 70, 229, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 46%, transparent)'
    },
    shellClasses: 'font-mono theme-cyber-samurai-onyx'
  },
  colorVars: {
    '--accent': '#4F46E5',
    '--accent-foreground': '#060608',
    '--background': '#060608',
    '--border': '#2D2427',
    '--card': '#0C1014',
    '--card-border-active': 'rgba(79, 70, 229, 0.58)',
    '--card-completed': '#0A0D10',
    '--card-foreground': '#F3F6FB',
    '--card-glow': 'rgba(79, 70, 229, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060608',
    '--foreground': '#F3F6FB',
    '--hold-fill': '#4F46E5',
    '--input': '#2D2427',
    '--modal-bg': '#060608',
    '--modal-border': '#2D2427',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 0 0 1px rgba(79, 70, 229, 0.24)',
    '--muted': '#2D2427',
    '--muted-foreground': '#D5D9E1',
    '--nav-active': '#4F46E5',
    '--nav-bg': '#0C1014',
    '--popover': '#0C1014',
    '--popover-foreground': '#F3F6FB',
    '--primary': '#4F46E5',
    '--primary-foreground': '#060608',
    '--ring': '#4F46E5',
    '--secondary': '#2D2427',
    '--secondary-foreground': '#F3F6FB',
    '--streak': '#4F46E5',
    '--success': '#22c55e',
    '--success-foreground': '#060608',
    '--xp': '#4F46E5',
    '--xp-bg': '#0C1014'
  },
  resolvedVars: {
    '--accent': '#4F46E5',
    '--accent-foreground': '#060608',
    '--accent-foreground-hsl': '240 14% 3%',
    '--accent-foreground-oklch': 'from #060608 l c h',
    '--accent-hsl': '243 75% 59%',
    '--accent-oklch': 'from #4F46E5 l c h',
    '--background': '#060608',
    '--background-hsl': '240 14% 3%',
    '--background-oklch': 'from #060608 l c h',
    '--border': '#2D2427',
    '--border-hsl': '340 11% 16%',
    '--border-oklch': 'from #2D2427 l c h',
    '--border-w': '1px',
    '--card': '#0C1014',
    '--card-border-active': 'rgba(79, 70, 229, 0.58)',
    '--card-completed': '#0A0D10',
    '--card-completed-hsl': '210 23% 5%',
    '--card-completed-oklch': 'from #0A0D10 l c h',
    '--card-foreground': '#F3F6FB',
    '--card-foreground-hsl': '217 50% 97%',
    '--card-foreground-oklch': 'from #F3F6FB l c h',
    '--card-glow': 'rgba(79, 70, 229, 0.10)',
    '--card-hsl': '210 25% 6%',
    '--card-oklch': 'from #0C1014 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060608',
    '--destructive-foreground-hsl': '240 14% 3%',
    '--destructive-foreground-oklch': 'from #060608 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3F6FB',
    '--foreground-hsl': '217 50% 97%',
    '--foreground-oklch': 'from #F3F6FB l c h',
    '--hold-fill': '#4F46E5',
    '--hold-fill-hsl': '243 75% 59%',
    '--hold-fill-oklch': 'from #4F46E5 l c h',
    '--input': '#2D2427',
    '--input-hsl': '340 11% 16%',
    '--input-oklch': 'from #2D2427 l c h',
    '--modal-bg': '#060608',
    '--modal-bg-hsl': '240 14% 3%',
    '--modal-bg-oklch': 'from #060608 l c h',
    '--modal-border': '#2D2427',
    '--modal-border-hsl': '340 11% 16%',
    '--modal-border-oklch': 'from #2D2427 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 0 0 1px rgba(79, 70, 229, 0.24)',
    '--muted': '#2D2427',
    '--muted-foreground': '#D5D9E1',
    '--muted-foreground-hsl': '220 17% 86%',
    '--muted-foreground-oklch': 'from #D5D9E1 l c h',
    '--muted-hsl': '340 11% 16%',
    '--muted-oklch': 'from #2D2427 l c h',
    '--nav-active': '#4F46E5',
    '--nav-active-hsl': '243 75% 59%',
    '--nav-active-oklch': 'from #4F46E5 l c h',
    '--nav-bg': '#0C1014',
    '--nav-bg-hsl': '210 25% 6%',
    '--nav-bg-oklch': 'from #0C1014 l c h',
    '--popover': '#0C1014',
    '--popover-foreground': '#F3F6FB',
    '--popover-foreground-hsl': '217 50% 97%',
    '--popover-foreground-oklch': 'from #F3F6FB l c h',
    '--popover-hsl': '210 25% 6%',
    '--popover-oklch': 'from #0C1014 l c h',
    '--primary': '#4F46E5',
    '--primary-foreground': '#060608',
    '--primary-foreground-hsl': '240 14% 3%',
    '--primary-foreground-oklch': 'from #060608 l c h',
    '--primary-hsl': '243 75% 59%',
    '--primary-oklch': 'from #4F46E5 l c h',
    '--radius': '0px',
    '--ring': '#4F46E5',
    '--ring-hsl': '243 75% 59%',
    '--ring-oklch': 'from #4F46E5 l c h',
    '--secondary': '#2D2427',
    '--secondary-foreground': '#F3F6FB',
    '--secondary-foreground-hsl': '217 50% 97%',
    '--secondary-foreground-oklch': 'from #F3F6FB l c h',
    '--secondary-hsl': '340 11% 16%',
    '--secondary-oklch': 'from #2D2427 l c h',
    '--shadow-card': '0 0 0 1px rgba(79, 70, 229, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 46%, transparent)',
    '--streak': '#4F46E5',
    '--streak-hsl': '243 75% 59%',
    '--streak-oklch': 'from #4F46E5 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#060608',
    '--success-foreground-hsl': '240 14% 3%',
    '--success-foreground-oklch': 'from #060608 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(243 75% 59% / 0.15)',
    '--xp': '#4F46E5',
    '--xp-bg': '#0C1014',
    '--xp-bg-hsl': '210 25% 6%',
    '--xp-bg-oklch': 'from #0C1014 l c h',
    '--xp-hsl': '243 75% 59%',
    '--xp-oklch': 'from #4F46E5 l c h'
  }
}
